import React from 'react';
import { useSelector } from 'react-redux';


// import logger from '../utils/logger';
import { getDialogList } from '../data/dialogs/selectors';

import DIALOG_KEYS_TO_COMPONENTS from '../data/dialogs/keys';

const DialogsRoot = function(_props) {

	const dialogs = useSelector(getDialogList);

	const activeDialog = dialogs.length > 0 ? dialogs[dialogs.length - 1] : null;
	const activeDialogComponent = activeDialog?.key ? DIALOG_KEYS_TO_COMPONENTS[activeDialog.key] : null;


	return activeDialog && activeDialogComponent ?
		React.createElement(activeDialogComponent, { ...activeDialog.props, dialogId: activeDialog.id }, null)
		:
		null;

}

export default DialogsRoot;